/*
 * /producer/new (create page)
 */
import { Card, CardContent, CardHeader, CardTitle, Container, Page, PageHeader } from "@emr/react-ui"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import type { Producer } from "@emr/db/client"
import { ProducerForm } from "../../features/producer/producer-form"

export const Route = createFileRoute("/producer/new")({
	component: NewProducerPage,
})

function NewProducerPage() {
	const navigate = useNavigate()

	function handleSuccess(producer: Producer) {
		navigate({ to: "/producer/$producerId", params: { producerId: producer.id } })
	}

	return (
		<Page>
			<Container width="xl" padding="lg" gap="lg">
				<PageHeader title="New Producer" />
				<Card>
					<CardHeader>
						<CardTitle>Producer Information</CardTitle>
					</CardHeader>
					<CardContent>
						<ProducerForm onSuccess={handleSuccess} />
					</CardContent>
				</Card>
			</Container>
		</Page>
	)
}
